import { inject, Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private _apiService: ApiService = inject(ApiService);

  constructor() { }

  createSubscription() {
    return this._apiService.post(`/subscriptions/`, {});
  }

  createInvoice() {
    return this._apiService.post(`/invoices/subscription/`, {});
  }

  getInvoices() {
    return this._apiService.get(`/invoices/subscription/`);
  }

  payInvoice(invoiceId: string) {
    return this._apiService.post('/invoices/create-payment-session/', {'invoice_id': invoiceId});
  }

  verifyPayment(paymentId: string): Observable<any> {
    return this._apiService.get(`/invoices/verify-payment/${paymentId}/`);
  }
}
